let CommutingOption = Backbone.Model.extend({
        defaults:
            {
                name: null,
                durationMins: appConfig.commuting.duration.defaultValue,
                selected: false,
            },

        getName: function () {
            return this.get('name');
        },

        getDuration: function () {
            return parseInt(this.get('durationMins'));
        },

        setDuration: function (durationMins) {
            this.set('durationMins', parseInt(durationMins));
        },

        isSelected: function () {
            return this.get('selected');
        },

        setSelected: function (isSelected) {
            this.set('selected', isSelected);
        },

        loadIn: function (optionsList) {
            let thisObj = this;
            let match = optionsList.find(function (x) {
                return x.getName() === thisObj.getName();
            });
            if (match !== undefined) {
                this.setSelected(match.isSelected());
                this.setDuration(match.getDuration());
            }
            return this;
        },
    }
);

function CreateCommutingOption(attributes) {
    return new CommutingOption(attributes);
}

let CommutingOptionList = Backbone.Collection.extend({
        model: CommutingOption
    }
);


let YourCommuting = Backbone.Model.extend({
    defaults: {
        commutingOptions: null,
    },

    initialize: function () {
        let loadCommutingOptions = new CommutingOptionList(unpackList(this.getCommutingOptions(), CreateCommutingOption));
        let commutingOptions = new CommutingOptionList();

        _.each(appConfig.commuting.options, function (commutingOption) {
            commutingOptions.add(new CommutingOption({name: commutingOption}).loadIn(loadCommutingOptions))
        });
        this.set('commutingOptions', commutingOptions);
    },

    getCommutingOptions: function () {
        return this.get('commutingOptions');
    },

    getCommutingOptionFor: function (name) {
        return this.getCommutingOptions().find((x) => x.getName() === name);
    },

    averageUtilisedHours: function () {
        let minsCommute = 0;
        this.getCommutingOptions().each(function (commuteOption) {
            if (commuteOption.isSelected()) {
                minsCommute += commuteOption.getDuration();
            }
        });
        let daysInOffice = plannerApplication.studyPlannerProfile.getWork().getDaysAWeekInOffice().length;
        let avgHoursCommute = minsCommute * daysInOffice / 7.0 / 60.0;
        appLogAttr('commute', 'avgHoursCommute', avgHoursCommute);
        return avgHoursCommute;
    },

    getDuration: function() {
        let minsCommute = 0;
        this.getCommutingOptions().each(function (commuteOption) {
            if (commuteOption.isSelected()) {
                minsCommute += commuteOption.getDuration();
            }
        });
        return minsCommute;
    }
});
